/**
 * Experiment to give FD retailers FOI. This XP is limited to the logged out user experience.
 * https:www.notion.so/faire/FOI-for-FD-retailers-c90bb663c6d74970976c30c1fc4c967d?pvs=4
 */
export const FOI_FOR_FD_LOGGED_OUT_240916 = 'FOI_FOR_FD_LOGGED_OUT_240916';
